import * as React from "react"
import { Link } from "react-router-dom"
import { ChevronLeft, Ghost } from "ui/icons"

type Props = {

}

export const NotFoundPage = ({

}: Props) => {
    return (
        <div className="px-4 md:px-6 py-10 md:py-16 flex justify-center">
            <div className="relative w-full max-w-2xl overflow-hidden rounded-3xl ring-1 ring-ink/[0.06] dark:ring-white/10 bg-gradient-to-br from-brand-50 via-white to-fuchsia-50/60 dark:from-color8 dark:via-color8 dark:to-color9 shadow-soft">
                <div aria-hidden className="pointer-events-none absolute -top-24 -right-16 w-80 h-80 rounded-full bg-fuchsia-300/25 dark:bg-fuchsia-500/10 blur-3xl" />
                <div aria-hidden className="pointer-events-none absolute -bottom-32 -left-10 w-96 h-72 rounded-full bg-brand-300/25 dark:bg-brand-500/10 blur-3xl" />
                <div className="relative flex flex-col items-center text-center px-6 py-14 md:py-16">
                    <span className="grid place-items-center w-16 h-16 rounded-2xl bg-white/90 dark:bg-color7 ring-1 ring-ink/[0.06] dark:ring-white/10 shadow-soft text-brand-600 dark:text-brand-300">
                        <Ghost className="w-8 h-8 fill-current" />
                    </span>
                    <div aria-hidden className="mt-6 text-[88px] md:text-[112px] leading-none font-extrabold tracking-[-0.06em] bg-gradient-to-br from-brand-600 via-violet-500 to-fuchsia-500 bg-clip-text text-transparent select-none">404</div>
                    <h1 className="section-label mt-4">Error 404!</h1>
                    <p className="page-title mt-2">Page introuvable</p>
                    <Link to="/" className="button button-secondary h-11 px-5 mt-8 gap-1.5">
                        <ChevronLeft className="w-4 h-4 stroke-2" />
                        Retour à l'accueil
                    </Link>
                </div>
            </div>
        </div>
    )
}
